import { useMutation } from '@tanstack/react-query'
import { ErrorModel } from '@/shared/api/BaseAPI.model'
import ChatBotAPI from '../api/ChatBotAPI'

type ChatRequest = {
  message: string
  language: string
  history: { role: 'user' | 'assistant'; content: string }[]
}

export function useChatBotQuery() {
  const { mutate: postMessage, isPending } = useMutation<
    string,
    ErrorModel,
    ChatRequest
  >({
    mutationFn: ({ message, history, language }) =>
      ChatBotAPI.postMessage(message, history, language)
  })

  return {
    postMessage,
    isPending
  }
}
